import { Sun, Cloud, CloudRain, CloudSnow, CloudLightning, CloudFog, CloudSun, Droplets } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const icona = (c) => (c >= 95 ? CloudLightning : c >= 71 && c <= 86 ? CloudSnow : c >= 51 ? CloudRain : c >= 45 ? CloudFog : c >= 3 ? Cloud : c >= 1 ? CloudSun : Sun);
const giorno = (s, i) => (i === 0 ? "Oggi" : i === 1 ? "Domani" : new Date(`${s}T12:00:00`).toLocaleDateString("it-IT", { weekday: "long", day: "numeric" }));
const n0 = (v) => (v == null ? "—" : Math.round(v));

// Popup meteo: oggi e prossimi 3 giorni con stima di produzione
export function ClienteMeteo({ open, onClose, meteo, comune }) {
  const prev = meteo?.previsioni || [];
  const max = Math.max(1, ...prev.map((g) => g.stima_kwh || 0));
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="cliente-font max-w-md rounded-3xl bg-white text-slate-800" data-testid="cliente-meteo-dialog">
        <DialogHeader>
          <DialogTitle className="text-lg font-extrabold">Meteo e produzione prevista</DialogTitle>
          <DialogDescription className="text-xs font-semibold text-slate-400">{comune || "Il tuo impianto"} · stima indicativa in base al sole previsto</DialogDescription>
        </DialogHeader>
        <ul className="space-y-2">
          {prev.map((g, i) => {
            const I = icona(g.codice ?? 3);
            return (
              <li key={g.data} className="flex items-center gap-3 rounded-2xl bg-slate-50 px-3 py-2.5" data-testid={`cliente-meteo-giorno-${i}`}>
                <I className="h-8 w-8 shrink-0" style={{ color: I === Sun || I === CloudSun ? "#EAB308" : "#64748B" }} />
                <div className="min-w-0 flex-1">
                  <b className="block text-sm font-extrabold capitalize">{giorno(g.data, i)}</b>
                  <span className="block truncate text-xs text-slate-500">
                    {g.cielo} · {n0(g.t_min)}° / {n0(g.t_max)}°{g.pioggia_mm > 0.2 && <><Droplets className="mx-1 inline h-3 w-3" />{g.pioggia_mm.toLocaleString("it-IT", { maximumFractionDigits: 1 })} mm</>}
                  </span>
                  <div className="mt-1.5 h-1.5 overflow-hidden rounded-full bg-slate-200"><div className="h-full rounded-full bg-amber-400" style={{ width: `${((g.stima_kwh || 0) / max) * 100}%` }} /></div>
                </div>
                <div className="text-right">
                  <b className="block text-lg font-extrabold leading-none" data-testid={`cliente-meteo-stima-${i}`}>{g.stima_kwh != null ? `${g.stima_kwh.toLocaleString("it-IT")}` : "—"}</b>
                  <span className="text-[10px] font-bold uppercase text-slate-400">kWh stimati</span>
                </div>
              </li>
            );
          })}
        </ul>
      </DialogContent>
    </Dialog>
  );
}
